var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.61 169.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#de340c;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MTS_LOGO_GRP",
    "data-name": "MTS LOGO GRP"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "N",
    className: "cls-1",
    points: "402.52 132.94 407.53 132.94 424.03 154.22 424.03 132.94 429.35 132.94 429.35 163.72 424.82 163.72 407.84 141.82 407.84 163.72 402.52 163.72 402.52 132.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-1",
    d: "M346.11,148.42v-.09a16.1,16.1,0,0,1,32.19-.09v.09a16.1,16.1,0,0,1-32.19.09m26.52,0v-.09c0-6-4.36-11-10.47-11s-10.38,4.88-10.38,10.86v.09c0,6,4.35,10.95,10.47,10.95s10.38-4.88,10.38-10.86"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "I",
    className: "cls-1",
    x: 316.16,
    y: 132.94,
    width: 5.41,
    height: 30.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-1",
    d: "M268,159.24l3.26-3.87c2.95,2.55,5.89,4,9.72,4,3.34,0,5.45-1.54,5.45-3.87v-.09c0-2.2-1.23-3.39-6.95-4.71-6.55-1.58-10.24-3.51-10.24-9.19v-.08c0-5.28,4.39-8.93,10.51-8.93a17.05,17.05,0,0,1,11.17,3.87l-2.9,4.09a14,14,0,0,0-8.36-3.17c-3.17,0-5,1.63-5,3.65V141c0,2.37,1.4,3.43,7.3,4.84,6.5,1.58,9.89,3.91,9.89,9V155c0,5.76-4.53,9.19-11,9.19A19,19,0,0,1,268,159.24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "I-2",
    "data-name": "I",
    className: "cls-1",
    x: 238.74,
    y: 132.94,
    width: 5.41,
    height: 30.79
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "V",
    className: "cls-1",
    points: "209.63 132.94 200.4 156.6 191.12 132.94 185.13 132.94 197.93 163.94 202.68 163.94 215.48 132.94 209.63 132.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "E",
    className: "cls-1",
    points: "140.64 132.94 140.64 163.72 163.68 163.72 163.68 158.88 146.05 158.88 146.05 150.62 161.49 150.62 161.49 145.78 146.05 145.78 146.05 137.77 163.46 137.77 163.46 132.94 140.64 132.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "L",
    className: "cls-1",
    points: "95.75 132.94 95.75 163.72 117.34 163.72 117.34 158.8 101.16 158.8 101.16 132.94 95.75 132.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "E-2",
    "data-name": "E",
    className: "cls-1",
    points: "48.61 132.94 48.61 163.72 71.66 163.72 71.66 158.88 54.02 158.88 54.02 150.62 69.46 150.62 69.46 145.78 54.02 145.78 54.02 137.77 71.44 137.77 71.44 132.94 48.61 132.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "T",
    className: "cls-1",
    points: "0.24 132.94 0.24 137.95 10.01 137.95 10.01 163.72 15.46 163.72 15.46 137.95 25.22 137.95 25.22 132.94 0.24 132.94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "I-3",
    "data-name": "I",
    className: "cls-1",
    x: 411.29,
    y: 30.73,
    width: 17.86,
    height: 64.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-1",
    d: "M322.16,30.73h30.32c9.8,0,16.58,2.56,20.88,7,3.76,3.66,5.68,8.61,5.68,14.93v.18c0,9.8-5.22,16.31-13.19,19.69l15.3,22.35H360.63L347.72,75.43h-7.79V94.84H322.16Zm29.5,30.77c6,0,9.52-2.93,9.52-7.6v-.18c0-5-3.66-7.6-9.62-7.6H339.93V61.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O_KORU",
    className: "cls-1",
    d: "M291.29,57c-2.07-43.09-50.58-65.61-86.19-37C230,11.15,259.52,19,269.25,47.38c9.05,26.38-16.27,51-41,40.56-7.77-3.27-18.82-13.52-16.65-23A10.75,10.75,0,0,1,231.36,62,10,10,0,0,0,245,65.66c13.6-9.68-2.45-26.07-15.45-28.73-18-3.67-34,5.9-37.53,22-5.21,23.92,11.3,41.22,28.71,48,35.26,13.78,72.09-12.18,70.55-50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-1",
    d: "M124.58,30.27H141.7L169,94.84H150l-4.67-11.45H120.55L116,94.84H97.28Zm15.57,39.29L133,51.34l-7.23,18.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "TOHUTO_MACRON",
    "data-name": "TOHUTO/MACRON",
    className: "cls-1",
    x: 114.57,
    y: 4.67,
    width: 35.39,
    height: 11.25
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "M",
    className: "cls-1",
    points: "0 30.73 18.78 30.73 34.07 55.55 49.37 30.73 68.15 30.73 68.15 94.84 50.47 94.84 50.47 58.02 34.07 83.12 33.71 83.12 17.41 58.2 17.41 94.84 0 94.84 0 30.73"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 476.61,
    height: 169.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaori);
export default __webpack_public_path__ + "static/media/maori.ba2539938a4061062d8607cd3db865b9.svg";
export { ForwardRef as ReactComponent };